import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { Input } from '@/common/ui/input'
import { Label } from '@/common/ui/label'

interface MaintenanceKeyConfirmDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	title: string
	description?: string
	confirmLabel?: string
	onConfirm: (password: string) => void
	isPending?: boolean
}

export default function MaintenanceKeyConfirmDialog({
	open,
	onOpenChange,
	title,
	description = 'กรอกรหัสยืนยัน (BANK_MAINTENANCE_KEY) เพื่อดำเนินการ',
	confirmLabel = 'ยืนยัน',
	onConfirm,
	isPending,
}: MaintenanceKeyConfirmDialogProps) {
	const [password, setPassword] = useState('')

	const handleConfirm = () => {
		if (!password.trim()) return
		onConfirm(password.trim())
		setPassword('')
	}

	const handleOpenChange = (next: boolean) => {
		if (!next) setPassword('')
		onOpenChange(next)
	}

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					{description && (
						<p className="text-sm text-muted-foreground">{description}</p>
					)}
				</DialogHeader>
				<div className="space-y-2 py-2">
					<Label htmlFor="maintenance-key">รหัสยืนยัน</Label>
					<Input
						id="maintenance-key"
						type="password"
						placeholder="กรอกรหัส"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
						autoFocus
						disabled={isPending}
					/>
				</div>
				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={() => handleOpenChange(false)}
						disabled={isPending}
					>
						ยกเลิก
					</Button>
					<Button
						type="button"
						onClick={handleConfirm}
						disabled={!password.trim() || isPending}
					>
						{isPending ? 'กำลังดำเนินการ...' : confirmLabel}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
